<template>
    <div v-if="isLeserserviceLeitungOrHigher" class="delete-customer-btn">
        <template>
            <div v-if="alternativeBtn">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn color="error" :disabled="disabled" style="width: 100%" @click="showDialog = true" class="mb-2" v-on="on">Benutzer löschen</v-btn>
                    </template>
                    <div class="max-width-btn">
                        Vollständiges Löschen des Benutzerprofils und Generierung eines Löschprotokolls für den Benutzer im Sinne der DSGVO.

                    </div>
                </v-tooltip>
            </div>
            <div v-if="!alternativeBtn">
                <v-tooltip left>
                    <template #activator="{ on }">
                        <v-btn v-bind="$attrs" text icon color="error" @click="showDialog = true" v-on="on">
                            <v-icon v-bind="$attrs">mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Benutzer löschen</span>
                </v-tooltip>
            </div>
        </template>
        <v-dialog
            v-model="showDialog"
            max-width="500"
            persistent
            class="flex-none"
        >
            <v-card>
                <v-card-title class="headline" primary-title>
                    Benutzer löschen
                </v-card-title>
                <v-card-text>
                    <p class="mb-2">
                        Alle vorhandenen Daten werden konform der DSGVO permanent entfernt und ein Löschprotokoll als Download zurückgegeben.
                        Bitte ändern Sie den Dateinamen des Löschprotokolls in die Email-Adresse des Benutzers und legen Sie diese im Ordner <b>W:\CC-NB\Löschung Kundendaten Archiv</b> ab.
                        <b>Achtung: Dieser Vorgang kann nicht rückgängig gemacht werden!</b>
                    </p>
                    <div class="center-progress-circular" v-if="isCheckingCustomer">
                        <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
                    </div>
                    <div v-if="!isCheckingCustomer">
                        <LabelValue label="Name" :value="fullname" />
                        <LabelValue label="Email" :value="email" />
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="warning" outlined @click="abbort" :disabled="loading || isCheckingCustomer">Abbrechen</v-btn>
                    <v-btn color="error" outlined :loading="loading && processing" :disabled="loading || isCheckingCustomer" @click="deleteCustomerHandler">
                        Unwiderruflich Löschen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';
import LabelValue from '@/components/LabelValue.vue';

export default {
    name: 'DeleteCustomerBtn',
    props: ['ssoId', 'alternativeBtn', 'disabled'],
    components: {
        LabelValue,
    },
    data() {
        return {
            showDialog: false,
            processing: false,
        };
    },
    computed: {
        ...mapState('deleteCustomer', [
            'loading',
            'email',
            'isCheckingCustomer',
        ]),
        ...mapGetters('deleteCustomer', ['fullname']),
        ...mapGetters(['isLeserserviceLeitungOrHigher']),
    },
    methods: {
        abbort() {
            // emit close with successfull = false
            this.$emit('close', false);
            this.showDialog = false;
            this.snackInfo('Das Löschen des Nutzers wurde abgebrochen.');
        },
        deleteCustomerHandler() {
            this.processing = true;
            this.deleteCustomer()
                .then(() => {
                    // emit close with successfull = true
                    this.$emit('close');
                    this.snackSuccess('Der Nutzer wurde erfolgreich gelöscht');
                    this.showDialog = false;
                })
                .catch(() => {
                    this.snackError('Der Nutzer konnte nicht gelöscht werden.');
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        ...mapActions('deleteCustomer', ['checkCustomer', 'deleteCustomer']),
        ...mapMutations('deleteCustomer', ['resetState']),
        ...mapMutations('snackbar', {
            snackError: 'error',
            snackSuccess: 'success',
            snackInfo: 'info',
        }),
    },
    watch: {
        showDialog(value) {
            if (value) {
                this.checkCustomer(this.ssoId)
                    .then(() => null)
                    .catch(() => {
                        this.snackError('Es ist ein Fehler beim Überprüfen des Nutzers aufgetreten.');
                        this.showDialog = false;
                    });
            } else {
                this.resetState();
                this.processing = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
    .center-progress-circular {
        display: flex;
        height: 100px;
        justify-content: center;
        align-items: center;
        > * {
            flex: none;
        }
    }
</style>
